<div class="rt-card rt-card-clickable" padding>
  <div class="body">
    <div class="title-details">
      <div margin-bottom-small class="title">
        @if (fieldsVisibilityMap.title) {
          <span class="text">{{ offer.title }}</span>
        }
        @if (fieldsVisibilityMap.job_id) {
          <span class="badge-wrapper"
            ><rt-badge
              [text]="'#' + offer.guid"
              color="secondary"
              [rtClickToCopy]="offer.guid"
              [rtTooltip]="'app.offer.copy_id' | translate"
            ></rt-badge
          ></span>
        }
        @if (offer.wysiwygEditor === 'redactor') {
          <span class="badge-wrapper"
            ><rt-badge
              [text]="'app.offer.action_needed' | translate"
              [color]="'warning-tint'"
              [iconName]="'warning'"
              [rtTooltip]="'app.offer.action_needed_tooltip' | translate"
            ></rt-badge
          ></span>
        }
      </div>
      <div class="details">
        @if (!isVisibleOnScreen) {
          <rt-placeloader [class.disable-animations]="!isVisibleOnScreen"></rt-placeloader>
        }
        @if (isVisibleOnScreen) {
          @if (fieldsVisibilityMap.department && offer.department && sort !== 'department') {
            <span
              #departmentRef
              [rtTooltip]="offer.department"
              [rtTooltipPosition]="'below'"
              [rtTooltipEnabled]="departmentLabelTooltipEnabled"
              [class.restricted]="fieldsVisibilityMap.location && locationIds.length"
              class="details-item department"
              text-weight-semi-bold
            >
              {{ offer.department }}
            </span>
          }
          <ng-container *ngTemplateOutlet="locationsDetails"></ng-container>
          <ng-container *ngTemplateOutlet="workModelDetails"></ng-container>
          <ng-container *ngTemplateOutlet="priorityDetails"></ng-container>
        }
      </div>
    </div>
    <div class="actions">
      @if (!isVisibleOnScreen) {
        <rt-placeloader [class.disable-animations]="!isVisibleOnScreen"></rt-placeloader>
      }
      @if (isVisibleOnScreen) {
        <rt-group variant="horizontal">
          @if (hasPromote) {
            <rt-button variant="outline" [routerLink]="['/offers', offer.slug, 'promote']">
              <rt-icon name="bullhorn" margin-right-small-xx></rt-icon>
              <span>{{ 'app.common.promote' | translate }}</span>
            </rt-button>
          }
          @if (hasEdit) {
            <rt-button variant="outline" (click)="editOffer()">
              <rt-icon name="edit"></rt-icon>
              <span>{{ 'app.common.edit' | translate }}</span>
            </rt-button>
          }
          @if (abilities.manageJobs) {
            <rt-actions-dropdown-container [offer]="offer" type="list" margin-left-small-xx>
            </rt-actions-dropdown-container>
          }
        </rt-group>
      }
    </div>
  </div>
  @if (isVisibleOnScreen) {
    <rt-divider variant="medium line"></rt-divider>
    <div class="footer">
      <rt-offers-footer-counters [counters]="counters"></rt-offers-footer-counters>
      <div class="actions">
        @if (offer.jobScheduler) {
          <rt-job-scheduler-info
            [schedulerData]="offer.jobScheduler"
            margin-right-small
            padding-top-small-xx
          ></rt-job-scheduler-info>
        }
        <rt-follow-button
          margin-left-small
          [type]="'offer'"
          [followed]="offer.followed"
          [loading]="followLoading"
          [kind]="offer.kind"
          (followClick)="followClick()"
          (unfollowClick)="followClick()"
        >
        </rt-follow-button>
        @if (offer.kind !== OfferKind.TalentPool) {
          <rt-statuses-dropdown-container [offer]="offer"> </rt-statuses-dropdown-container>
        }
      </div>
    </div>
  }
  <a [routerLink]="detailsRouterLink" class="details-link"></a>
</div>

<ng-template #locationsDetails>
  @if (fieldsVisibilityMap.location && locationIds.length) {
    @if (fieldsVisibilityMap.department && offer.department && sort !== 'department') {
      <rt-divider variant="dot"> </rt-divider>
    }
    <rt-assigned-locations-info-container
      [locationIds]="locationIds"
      [showIcon]="true"
    ></rt-assigned-locations-info-container>
  }
</ng-template>

<ng-template #workModelDetails>
  @if (
    offer.kind === OfferKind.Job &&
    (offer.onSite || offer.hybrid || offer.remote) &&
    fieldsVisibilityMap.work_model
  ) {
    @if (
      (fieldsVisibilityMap.department && offer.department) ||
      (fieldsVisibilityMap.location && locationIds.length)
    ) {
      <rt-divider variant="dot"></rt-divider>
    }
    @if (offer.onSite) {
      <div class="details-item work-model">
        <rt-icon
          name="domain"
          [rtTooltip]="'app.offer_form.work_model_section.on_site.title' | translate"
          [rtTooltipEnabled]="shortenItemVersion"
          [rtTooltipPosition]="'below'"
          margin-right-small-xx
        ></rt-icon>
        @if (!shortenItemVersion) {
          <span>{{ 'app.offer_form.work_model_section.on_site.title' | translate }}</span>
        }
      </div>
    }
    @if (offer.hybrid) {
      <div [attr.margin-left-small-x]="offer.onSite || null" class="details-item work-model">
        <rt-icon
          name="hybrid"
          [rtTooltip]="'app.offer_form.work_model_section.hybrid.title' | translate"
          [rtTooltipEnabled]="shortenItemVersion"
          [rtTooltipPosition]="'below'"
          margin-right-small-xx
        ></rt-icon>
        @if (!shortenItemVersion) {
          <span>{{ 'app.offer_form.work_model_section.hybrid.title' | translate }}</span>
        }
      </div>
    }
    @if (offer.remote) {
      <div
        [attr.margin-left-small-x]="offer.onSite || offer.hybrid || null"
        class="details-item work-model"
      >
        <rt-icon
          name="nav-careershub"
          [rtTooltip]="'app.offer_form.work_model_section.remote.title' | translate"
          [rtTooltipEnabled]="shortenItemVersion"
          [rtTooltipPosition]="'below'"
          margin-right-small-xx
        ></rt-icon>
        @if (!shortenItemVersion) {
          <span>{{ 'app.offer_form.work_model_section.remote.title' | translate }}</span>
        }
      </div>
    }
  }
</ng-template>

<ng-template #priorityDetails>
  @if (offer.kind === OfferKind.Job && fieldsVisibilityMap.priority && offer.priority) {
    @if (hasElementsBeforePriority) {
      <rt-divider variant="dot"></rt-divider>
    }
    <div class="details-item priority" layout-horizontal layout-align-items-center>
      <rt-icon
        [name]="priorityDataMap[offer.priority].icon!"
        [colorToken]="priorityDataMap[offer.priority].iconColorToken || 'colorIconDefault'"
        [rtTooltip]="priorityDataMap[offer.priority].label"
        [rtTooltipEnabled]="shortenItemVersion"
        [rtTooltipPosition]="'below'"
        margin-right-small-xx
      ></rt-icon>
      @if (!shortenItemVersion) {
        <span>{{ priorityDataMap[offer.priority].label }}</span>
      }
    </div>
  }
</ng-template>
